<template>
  <div>
    <input
      type="checkbox"
      :checked="isChecked"
      @click="onClick"
    />
  </div>
</template>

<script>
export default {
  name: 'CheckboxRenderer',
  data() {
    return {
      params: null,
    };
  },
  computed: {
    isChecked() {
      return this.params.node.isSelected() || this.params.value;
    }
  },
  methods: {
    onClick(event) {
      event.stopPropagation();
      if (this.params.onClick) {
        this.params.onClick(this.params);
      }
    }
  },
  created() {
    this.params = this.params || {};
  }
}
</script>